/* eslint-disable import/prefer-default-export */
// export const API_URL = 'http://192.168.86.88:30040/api';
export const API_URL = 'https://api.dev.cotton-quiz.com/api';
export const OFFLINE = false;
export const LOCKTOMOROW = true;
